<template>
  <div
    class="palette-picker"
    @click="toggle">
    <div
      v-for="item in palettesList"
      :class="item.active?'active':'no-active'"
      :key="item.number"
      :data-palette="item.name"
      :active="item.active"
      :style="`background-color:${borderColor==='b'?'black':'white'};border:0.12rem solid #${borderColor==='b'?'fffffb':'0c0c0c'};z-index:${true === item.active?999:1};`"
      class="dot btn-box">{{ item.icon }}</div>
    <div
      :style="`border:0.12rem solid #${borderColor==='b'?'fffffb':'0c0c0c'};z-index:1;`"
      class="dot btn-box"
      data-palette="">P</div>
  </div>
</template>

<script>

import anime from 'animejs'

export default {
  props: {
    palettesList: {
      type: Array,
      default: () => [],
    },
    borderColor: {
      type: String,
      default: 'd',
    },
  },
  data () {
    return {
      isOpen: false,
      currentColor: null,
      palette: null,
    }
  },
  methods: {
    logMe (name, event) {
      console.log(name, event)
    },
    getKey (id) {
      return (Math.random().toString(36).substring(7) + id)
    },
    open () {
      anime({
        targets: document.querySelectorAll('.dot'),
        translateY: [
          '0rem',
          function (el, i, l) {
            return i * 2.2 + 'rem'
          },
        ],
        duration: 100,
        easing: 'easeInSine',
      })
      this.isOpen = true
    },
    close () {
      anime({
        targets: document.querySelectorAll('.dot'),
        translateY: [
          function (el, i, l) {
            return i * 2.2 + 'rem'
          },
          '0rem',
        ],
        duration: 100,
        easing: 'easeInSine',
      })
      this.isOpen = false
    },
    toggle (e) {
      if (this.isOpen === false) {
        this.open()
      } else {
        this.close()
        // data-palette in <template/>
        this.$emit('paletteChange', (this.palette = e.target.dataset.palette))

        /* THIS BLOCK IS NOT NEEDED: COMPONENT IS FORCED TO REFRESH
        // Better Array iteration
        this.palettesList.every(function (el) {
          el['active'] = false
        })

        let elements = document.querySelectorAll('.dot')

        // Nodelist Iteration remove active class
        Array.prototype.forEach.call(elements, function (el, i) {
          el.classList.remove('active')
        })
        e.target.classList.toggle('active')
        */
      }
    },
    toggleActive (e) {
      // console.log('event', e.target)
      let elements = document.querySelectorAll('.card')
      // Nodelist Iteration remove active class
      Array.prototype.forEach.call(elements, function (el, i) {
        el.classList.remove('active')
      })
      e.target.parentNode.parentNode.classList.add('active')
    },
  },
}
</script>

<style lang="scss" scoped>
.palette-picker {
  position: relative;
  height: 100%;
  width: 100%;
  .dot {
    box-sizing: border-box;
    transition: all 1s;
    position: absolute;
    height: 100%;
    width: 100%;
    //border-radius: 50%;
    opacity: .66;
    &.active {
      opacity: 1;
    }
  }
  .btn-box {
    text-align: center;
    font-weight: bold;
    font-size: 112%;
    line-height: 1.4;
    z-index: 998;
    overflow: hidden;
    &.white {
      background-color: white;
    }
  }
}
</style>
